// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"_2B22QS"};